//Import Libraries
import React, { useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import EditableTable from "./EditableTable";
import fieldsArr from "../fields";
import "../rociview.scss";
import { config } from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MetaSearchFilter from "./MetaSearchFilter";
import { useUserAuthentication } from "../../../utils/utils";
import { useHistory } from "react-router-dom";
import { ApprovalButton } from "../../../components/Approval/ApprovalButton";
import { ApprovalTable } from "../../../components/Approval/ApprovalTable";
import DynamicDialog from "../../../components/Dialog/Dialog";
import { HistoryAndLogsButton } from "../../../components/HistoryAndLogs/HistoryAndLogsButton";
import { HistoryAndLogsTable } from "../../../components/HistoryAndLogs/HistoryAndLogsTable";
import { SaveCallAuditLogs } from "../../../components/HistoryAndLogs/SaveCallAuditLogs";

let api = config.api.api_url;
// let api = process.env.REACT_APP_BACKEND_BASE_URL;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

function GoldTemplateView(props) {
  const { user, match, updateSourceInputs, updateAlert, source_data } = props;

  // STATES
  const [loading, setLoading] = useState(true);
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSearchFilterLoading, setIsSearchFilterLoading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isBackDialogOpen, setIsBackDialogOpen] = useState(false);
  const [isPlaceholderFetching, setIsPlaceholderFetching] = useState(false);
  const [isApproval, setIsApproval] = useState(false);
  const [isHistory, setIsHistory] = useState(false);
  const [isSaveAudit, setIsSaveAudit] = useState(false);
  const [isDynamicDialogOpen, setIsDynamicDialogOpen] = useState(false);
  const [dynamicDialogMessage, setDynamicDialogMessage] = useState();
  let history = useHistory();
  const { login } = useUserAuthentication();

  // FUNCTIONS
  async function getSources() {
    try {
      // code for initial data fetching
      const response = await fetch(
        api +
          `/gold_template_mapping/getdataset?role=${
            user?.role?.[0] || "AppAdmin"
          }`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("data", data);
      const DATASETS = data.data.map((item) => {
        return {
          label:
            item.dataset_name !== "Nielsen"
              ? item.dataset_name.toUpperCase()
              : item.dataset_name,
          value: item.dataset_name,
        };
      });
      updateSourceInputs("current_mapped_source", DATASETS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "warning",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  }
  const clearReduxStateForHistoryLogs = () => {
    updateSourceInputs("data_logs", []);
    updateSourceInputs("current_source_logs", "");
    updateSourceInputs("current_target_gold_layer_logs", "");
    updateSourceInputs("current_mapped_source_logs", []);
    updateSourceInputs("current_target_gold_layer_list_logs", []);
    updateSourceInputs("current_country_logs", "");
    updateSourceInputs("current_country_code_logs", "");
    updateSourceInputs("current_ssfFileId_logs", "");
    updateSourceInputs("is_initial_logs", false);
    updateSourceInputs("is_table_loading_logs", false);
    updateSourceInputs("current_mapped_country_logs", []);
    updateSourceInputs("current_ssf_file_id_logs", []);
  };

  const clearReduxState = () => {
    clearReduxStateForHistoryLogs();
    updateSourceInputs("is_file_uploaded", false);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
    updateSourceInputs("historyData", []);
    updateSourceInputs("historyTable_Header", []);
  };

  const clearReduxWithoutGoldLayerState = () => {
    updateSourceInputs("is_file_uploaded", false);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("current_usecase", "");
    updateSourceInputs("current_usecase_list", []);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  const getData = (row) => {};

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  const IS_ANY_ROWDATA_NULL = useMemo(() => {
    if (
      source_data.current_mapped_data &&
      source_data.current_mapped_data.length > 0 &&
      source_data.data.dropdown
    ) {
      const ExceptionKeys = [...source_data.data.dropdown.metadata_filter];

      return source_data?.current_mapped_data.some((singleRowData) => {
        return Object.keys(singleRowData.rowData).every(
          (key) =>
            ExceptionKeys.includes(key) || singleRowData.rowData[key] === null,
        );
      });
    } else {
      return false;
    }
  }, [
    source_data.current_mapped_data,
    source_data.current_ssfFileId,
    source_data.current_filter_value,
  ]);

  const IS_SAVE_BUTTON_ENABLE = useMemo(() => {
    const isEditing =
      source_data?.current_mapped_data?.some((item) => item.isEditing) || false;
    if (isEditing) return true;
    if (isTableDataSaving) return true;
    return false;
  }, [source_data.current_mapped_data, source_data.is_file_uploaded]);

  const IS_ANY_RECORDS_EDITED = useMemo(() => {
    if (source_data?.current_filter_value === "Create new") return true;
    if (source_data.is_file_uploaded) return true;
    return (
      source_data?.current_mapped_data?.some(
        (item) => item.isEdited === true,
      ) ?? false
    );
  }, [source_data.current_mapped_data, source_data.is_file_uploaded]);

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    // updateSourceInputs("data",[]);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("is_initial", true);
    getSources();
  }

  function mergeWithObj2Priority(obj1, obj2) {
    const commonKeys = Object.keys(obj1).filter((key) => key in obj2);

    if (commonKeys.length > 0) {
      // Merge and overwrite obj1 values with obj2 values for common keys
      return {
        ...obj1,
        ...obj2, // obj2 values take priority
      };
    } else {
      // No common keys – just merge all keys
      return {
        ...obj1,
        ...obj2,
      };
    }
  }

  const getSortedModifiedData = () => {
    const Temp_Modidified_Data = source_data.modified_mapped_data.map(
      (item) => {
        return {
          ...item,
          isEdited: item.isEdited,
          isNew: item.isNew,
          updated: {
            ...item.updated,
            COUNTRY_CODE: source_data.current_country_code,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            CREATED_BY: item.isNew
              ? user.mail || ""
              : item.updated.CREATED_BY || "",
            UPDATED_BY: !item.isNew
              ? user.mail || ""
              : item.updated.UPDATED_BY || "",
            ISNEW: item?.updated?.ISNEW
              ? item.updated.ISNEW
              : item?.isNew || false,
            ISDELETED: item?.updated?.ISDELETED
              ? item.updated.ISDELETED
              : item?.isDeleted || false,
            USER: user.mail || "",
          },
        };
      },
    );

    // Merge the Actual and updated object of modified data
    const Temp_modified_data_map = source_data.modified_mapped_data.map(
      (item) => {
        return mergeWithObj2Priority(item.actual, item.updated);
      },
    );

    const Current_Mapped_Data_With_Country_Code =
      source_data.current_mapped_data.map((item) => {
        return {
          ...item,
          rowData: {
            ...item.rowData,
            ISNEW: item?.rowData?.ISNEW
              ? item.rowData.ISNEW
              : item?.isNewData || false,
            ISDELETED: item?.updated?.ISDELETED
              ? item.updated.ISDELETED
              : false,
            COUNTRY_CODE: source_data.current_country_code,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
          },
        };
      });

    // Remove the data which is modified from the current mapped data
    const Changed_Rows_Removed_Data =
      Current_Mapped_Data_With_Country_Code.filter((item) => {
        const isDuplicate = Temp_modified_data_map.some((data) =>
          source_data.data.dropdown.duplicate_validation_attributes.every(
            (attribute) => item.rowData[attribute] === data[attribute],
          ),
        );

        // Keep only if it's NOT a duplicate
        return !isDuplicate;
      });

    // Structure the Changed_Rows_Removed_Data
    const Temp_UnChanged_Data_Two = Changed_Rows_Removed_Data.map((item) => {
      return {
        actual: item.rowData,
        updated: {
          ...item.rowData,
          CREATED_BY: "",
          UPDATED_BY: user?.mail || "",
          USER: user.mail || "",
        },
        isEdited: false,
        isNew: false,
        isDeleted: false,
      };
    });

    const MODIFIED_MAPPED_DATA = [
      ...Temp_Modidified_Data,
      ...Temp_UnChanged_Data_Two,
    ];

    // Sorting MODIFIED_MAPPED_DATA by making null as String (i., "null")
    const SORTED_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
      const KEYS = Object.keys(item.updated);
      const Actual = {};
      const Updated = {};

      KEYS.forEach((key) => {
        Actual[key] = item.actual[key] === null ? null : item.actual[key];
        Updated[key] = item.updated[key] === null ? null : item.updated[key];
      });

      return {
        ...item,
        actual: item.isNew ? {} : Actual,
        updated: Updated,
        isEdited: item.isEdited,
        isNew: item.isNew,
      };
    });

    return SORTED_MODIFIED_MAPPED_DATA;
  };

  const validateAnyRowHasARule = () => {
    const Rule_Attributes = source_data?.data?.dropdown?.rule_attributes || [];
    const TableData = source_data?.current_mapped_data || [];

    if (Rule_Attributes.length === 0) return true;

    const result = TableData.some((item) => {
      const RowData = item?.rowData || {};
      return Rule_Attributes?.includes(RowData?.MAPPING_TYPE || "");
    });

    return result;
  };

  const isValidStructure = (columns) => {
    const REQUIRED_COLUMNS =
      source_data?.data?.dropdown?.download_sample_columns || [];
    return Object.keys(REQUIRED_COLUMNS).every((col) => columns.includes(col));
  };

  const checkIsNoDuplicateData = () => {
    const DUPLICATE_VALIDATION_ATTRIBUTES =
      source_data?.data?.dropdown?.duplicate_validation_attributes || [];

    const Table_Data = source_data?.current_mapped_data || [];

    let hasDuplicate = false;

    // Reset validation state first
    let updatedData = Table_Data.map((row) => ({
      ...row,
      isValidated: true,
      errorMessage: "",
    }));

    for (let i = 0; i < updatedData.length; i++) {
      for (let j = i + 1; j < updatedData.length; j++) {
        const rowA = updatedData[i];
        const rowB = updatedData[j];

        const isDuplicate = DUPLICATE_VALIDATION_ATTRIBUTES.every(
          (attribute) => {
            const valA = rowA.rowData?.[attribute];
            const valB = rowB.rowData?.[attribute];

            if (valA === null && valB === null) return true;
            return valA === valB;
          },
        );

        if (isDuplicate) {
          hasDuplicate = true;

          updatedData[i] = {
            ...updatedData[i],
            isValidated: false,
            errorMessage: "It is a Duplicate record",
          };

          updatedData[j] = {
            ...updatedData[j],
            isValidated: false,
            errorMessage: "It is a Duplicate record",
          };
        }
      }
    }

    // Sort → invalid rows on top
    const FINAL_SORTED_MAPPED_DATA = [...updatedData].sort(
      (a, b) => a.isValidated - b.isValidated,
    );

    updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);

    return !hasDuplicate; // true = no duplicates, false = duplicates found
  };

  const testErrorRecords = (records) => {
    let MissingValues = {};
    const Current_Table_Data = records || [];

    const TABLE_HEAD_COLUMN_LIST =
      source_data?.data?.dropdown?.table_header_column_list || [];
    const EDIT_COLUMN_LIST =
      source_data?.data?.dropdown?.edit_model_column_list || [];
    const Free_Text_Applicable_Columns =
      source_data?.data?.dropdown?.free_text_applicable_columns || [];
    const Free_text_applicable_columns_for_Gold_target_column =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_target_column_name || [];
    const Free_text_applicable_columns_for_Harbor_Value =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_harbor_value || [];

    const Sorted_Mapped_Data = Current_Table_Data.map((item) => {
      TABLE_HEAD_COLUMN_LIST.forEach((column) => {
        // Skip if value is null
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return;
        }

        // Skip HARBOR_VALUE, GOLD_TARGET_COLUMN_NAME validation for mapped types
        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          Free_text_applicable_columns_for_Gold_target_column &&
          Free_text_applicable_columns_for_Gold_target_column.length > 0 &&
          Free_text_applicable_columns_for_Gold_target_column.includes(
            item?.rowData?.MAPPING_TYPE,
          ) &&
          Free_text_applicable_columns_for_Harbor_Value &&
          Free_text_applicable_columns_for_Harbor_Value.length > 0 &&
          Free_text_applicable_columns_for_Harbor_Value.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        // === DEPENDENT COLUMN CHECK ===
        if (column.is_dependent) {
          const Filtered_Dropdown_Data =
            source_data?.data?.dropdown?.[column.name] || [];
          const Parent_Column_Name = column.parent_column;
          const Parent_Column_Value = item.rowData?.[Parent_Column_Name];

          if (!Parent_Column_Name || !Parent_Column_Value) return;

          const Filtered_Final_Options = Filtered_Dropdown_Data.filter(
            (option) => option[Parent_Column_Name] === Parent_Column_Value,
          );

          if (!Filtered_Final_Options.length) return;

          const validOptions = Filtered_Final_Options[0][column.name] || [];
          const isValidated = validOptions.includes(item.rowData[column.name]);

          if (!isValidated) {
            MissingValues[column.name] = item.rowData[column.name];
          }
          return;
        }

        // === NORMAL COLUMN VALIDATION ===
        const editableColumn = EDIT_COLUMN_LIST.find(
          (data) => data.name === column.name && data.type === "select",
        );

        if (editableColumn) {
          const IS_ARRAY = editableColumn.isArray;
          const DROPDOWN_DATA_NEW = source_data?.data?.dropdown || {};
          const Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name] || [];

          let resultValid = false;

          if (IS_ARRAY) {
            if (Final_DropDown_Values.length === 0) {
              resultValid = true;
            } else {
              resultValid = Final_DropDown_Values.includes(
                item.rowData[column.name],
              );
            }
          } else {
            resultValid =
              Free_Text_Applicable_Columns.includes(column.name) &&
              Free_text_applicable_columns_for_Gold_target_column.includes(
                item?.rowData?.MAPPING_TYPE,
              ) &&
              Free_text_applicable_columns_for_Harbor_Value.includes(
                item?.rowData?.MAPPING_TYPE,
              )
                ? true
                : Array.isArray(Final_DropDown_Values) &&
                  Final_DropDown_Values.includes(item.rowData[column.name]);
          }

          if (!resultValid) {
            MissingValues[column.name] = item.rowData[column.name];
          }
          return;
        }
      });

      if (MissingValues && Object.keys(MissingValues).length > 0) {
        const Error_Message = Object.entries(MissingValues)
          .map(([key, value]) => {
            if (value && value.length > 0) {
              return `${key}: ${value}`;
            }
            return null;
          })
          .filter(Boolean)
          .join(" | ");

        const ITEM = {
          ...item,
          isValidated: false,
          errorMessage: `Values are Misatching for these columns ===> ${Error_Message}`,
        };

        MissingValues = {};
        return ITEM;
      }

      MissingValues = {};
      return item;
    });

    // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
    const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
      return a.isValidated - b.isValidated;
    });
    updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
    return MissingValues;
  };

  const validateTableDataValues = () => {
    const Current_Table_Data = source_data?.current_mapped_data || [];
    const DROPDOWN_DATA = source_data?.data?.dropdown || {};
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;
    const Free_Text_Applicable_Columns =
      source_data?.data?.dropdown?.free_text_applicable_columns || [];
    const Free_text_applicable_columns_for_Gold_target_column =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_target_column_name || [];
    const Free_text_applicable_columns_for_Harbor_Value =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_harbor_value || [];

    // test
    testErrorRecords(Current_Table_Data);

    const isValid = Current_Table_Data.every((item, indxxx) => {
      return TABLE_HEAD_COLUMN_LIST.map((column) => {
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          Free_text_applicable_columns_for_Gold_target_column &&
          Free_text_applicable_columns_for_Gold_target_column.length > 0 &&
          Free_text_applicable_columns_for_Gold_target_column.includes(
            item?.rowData?.MAPPING_TYPE,
          ) &&
          Free_text_applicable_columns_for_Harbor_Value &&
          Free_text_applicable_columns_for_Harbor_Value.length > 0 &&
          Free_text_applicable_columns_for_Harbor_Value.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        if (column.is_dependent) {
          let FinalOptions = [];
          const FilteredDropdownOptions = DROPDOWN_DATA[column.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          if (column.isMultiLayerArray) {
            const Parent_Column_Name = column.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name];

            const DEFAULT_VALUE_KEYS = Object.keys(
              DROPDOWN_DATA[column.multiLayerMetaName].defaultvalues,
            );

            const Is_Default = DEFAULT_VALUE_KEYS.includes(Parent_Column_Value);

            if (Is_Default) {
              const Default_Value_Key_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.defaultvalues?.[
                  Parent_Column_Value
                ] || "";

              FinalOptions =
                Default_Value_Key_Name && Default_Value_Key_Name.length > 0
                  ? FilteredDropdownOptions?.default?.[
                      Default_Value_Key_Name
                    ] || []
                  : [];

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              return isValidated;
            } else {
              const Value_key_name = Object.keys(FilteredDropdownOptions).find(
                (vkey) => {
                  if (!Parent_Column_Value || !Parent_Column_Value.length > 0)
                    return "";
                  return (
                    vkey.toLowerCase() === Parent_Column_Value.toLowerCase()
                  );
                },
              );

              const filteredFinalOptions =
                Parent_Column_Value !== null
                  ? FilteredDropdownOptions?.[Value_key_name] || {}
                  : {};

              const Layer_Two_Parent_Column_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.[
                  Parent_Column_Value
                ] || "";

              const Layer_Two_Parent_Column_Value =
                item.rowData[Layer_Two_Parent_Column_Name];

              FinalOptions =
                filteredFinalOptions &&
                Object.keys(filteredFinalOptions).length > 0
                  ? filteredFinalOptions?.[Layer_Two_Parent_Column_Value] || []
                  : [];

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              return isValidated;
            }
          } else {
            const Parent_Column_Name = item.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

            // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
            const filteredFinalOptions =
              Parent_Column_Value !== null
                ? FilteredDropdownOptions.find(
                    (option) =>
                      option[Parent_Column_Name] === Parent_Column_Value,
                  )
                : {};

            FinalOptions =
              filteredFinalOptions &&
              Object.keys(filteredFinalOptions).length > 0
                ? filteredFinalOptions[item.name]
                : [];

            const isValidated =
              FinalOptions?.includes(item.rowData[column.name]) ?? false;

            return isValidated;
          }
        } else {
          // CHECKS IF COLUMN IN THE CURRENT ITERATION HAS DROPDOWN FIELD
          let result = EDIT_COLUMN_LIST.find(
            (data) => data.type === "select" && column.name === data.name,
          );

          // IF YES THEN CHECKS IF THE COLUMNS DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          if (result && result.type === "select") {
            let Final_DropDown_Values;
            EDIT_COLUMN_LIST.map((editItem) => {
              if (editItem.name === column.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA[column.name];
              }
            });

            const isValidated =
              Final_DropDown_Values?.includes(item.rowData[column.name]) ??
              false;

            return isValidated;
          }
        }
      });
    });

    return isValid;
  };

  const validateTableData = () => {
    const Table_Data = source_data?.current_mapped_data || [];
    const fileColumns = Object.keys(Table_Data[0].rowData);

    // ALL COLUMNS AVAILABLE CHECK
    if (!isValidStructure(fileColumns)) {
      updateAlert({
        open: true,
        message:
          "Validation Failed! Invalid file structure. Required columns are missing, Please check and try again",
        severity: "Failed",
        closeFlag: true,
      });
      return false;
    }

    // DUPLICATE VALIDATION
    if (!checkIsNoDuplicateData()) {
      updateAlert({
        open: true,
        message:
          "Validation Failed! Duplicate records found, Kindly please check and try again",
        severity: "Failed ",
        closeFlag: true,
      });
      return false;
    }

    // INCLUDE/EXCLUDE VALIDATION
    if (!validateAnyRowHasARule()) {
      updateAlert({
        open: true,
        message:
          "Validation Failed! No rules found. Atleast one rule is required to save the changes",
        severity: "Failed ",
        closeFlag: true,
      });
      return false;
    }

    // DATA VALIDATION
    // if (!validateTableDataValues()) {
    //   updateAlert({
    //     open: true,
    //     message: `Validation Failed! Invalid column value found in the records`,
    //     severity: "success",
    //     closeFlag: true,
    //   });
    //   return false;
    // }

    return true;
  };

  // Function with Mock Data for Calculated Expression validation Flow
  const onSave = async () => {
    updateSourceInputs("is_initial", true);
    setIsTableDataSaving(true);
    setIsSaveDialogOpen(false);
    setIsSaveAudit(true);

    // TABLEDATA VALIDATION
    const VALIDATION_RESULT = validateTableData();
    if (!VALIDATION_RESULT) {
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
      updateSourceInputs("is_initial", false);
      setIsSaveAudit(false);
      return;
    }

    const Current_Save_Call_Audit_Log_data = {
      DATASET: source_data?.current_source || "",
      GOLD_TARGET_COLUMN: source_data?.current_target_gold_layer.label || "",
      COUNTRY_CODE: source_data?.current_country || "",
      HARBOR_SOURCE_FILE_ID: source_data?.current_ssfFileId || 0,
      PROCESSED_AT: null,
      IS_VALIDATION: "In Progress",
      STATUS: "In Progress",
    };

    updateSourceInputs("data", {
      ...source_data.data,
      dropdown: {
        ...source_data.data.dropdown,
        SAVE_CALL_AUDIT_RESULTS: [
          Current_Save_Call_Audit_Log_data,
          ...(source_data?.data?.dropdown?.SAVE_CALL_AUDIT_RESULTS || []),
        ],
      },
    });

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    let MODIFIED_MAPPED_DATA;
    if (source_data.current_filter_value === "Existing") {
      MODIFIED_MAPPED_DATA = getSortedModifiedData();
    } else {
      const Temp_Modidified_Data = source_data.modified_mapped_data.map(
        (item) => {
          return {
            actual: {},
            updated: item.updated,
            isEdited: item.isEdited,
            isNew: true,
          };
        },
      );

      MODIFIED_MAPPED_DATA =
        Temp_Modidified_Data?.map((item) => {
          const KEYS = Object.keys(item.updated);
          const Updated = {};

          KEYS.forEach((key) => {
            Updated[key] =
              item.updated[key] === null ? "null" : item.updated[key];
          });

          return {
            actual: {},
            updated: {
              ...Updated,
              COUNTRY: source_data.current_country,
              COUNTRY_CODE: source_data.current_country_code,
              HARBOR_SOURCE_FILE_ID: source_data.current_ssfFileId,
              TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
              CREATED_BY: user.mail || "",
              ISNEW: item?.updated?.ISNEW
                ? item.updated.ISNEW
                : item?.isNew || false,
              USER: user.mail || "",
            },
            isEdited: item.isEdited,
            isNew: true,
          };
        }) ?? [];
    }

    try {
      const params = new URLSearchParams({
        dataset_name: source_data?.current_target_gold_layer?.value || "",
        usecase: "gold_template_mapping",
        country: source_data?.current_country || "",
        file_id: source_data?.current_ssfFileId || "",
        target_gold_layer: source_data.current_target_gold_layer.label || "",
        userid: user.mail || "",
      });
      const response = await fetch(
        api + `/gold_template_mapping/add_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      updateAlert({
        open: true,
        message: "Validating the records",
        severity: "success",
        closeFlag: true,
      });
      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        // ⏳ WAIT 3 SECONDS
        // await delay(3000);

        clearReduxState();
        getSources();

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
        setIsSaveAudit(false);
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);
        updateSourceInputs("is_initial", false);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveAudit(false);
  };

  const onSaveAwaitingData = async () => {
    setIsTableDataSaving(true);
    setIsSaveDialogOpen(false);
    setIsSaveAudit(true);
    updateSourceInputs("is_initial", true);

    // TABLEDATA VALIDATION
    const VALIDATION_RESULT = validateTableData();
    if (!VALIDATION_RESULT) {
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
      updateSourceInputs("is_initial", false);
      setIsSaveAudit(false);
      return;
    }

    const Current_Save_Call_Audit_Log_data = {
      DATASET: source_data?.current_source || "",
      GOLD_TARGET_COLUMN: source_data?.current_target_gold_layer.label || "",
      COUNTRY_CODE: source_data?.current_country || "",
      HARBOR_SOURCE_FILE_ID: source_data?.current_ssfFileId || 0,
      PROCESSED_AT: null,
      IS_VALIDATION: "In Progress",
      STATUS: "In Progress",
    };

    updateSourceInputs("data", {
      ...source_data.data,
      dropdown: {
        ...source_data.data.dropdown,
        SAVE_CALL_AUDIT_RESULTS: [
          Current_Save_Call_Audit_Log_data,
          ...(source_data?.data?.dropdown?.SAVE_CALL_AUDIT_RESULTS || []),
        ],
      },
    });

    // Getting The MODIFIED_MAPPED_DATA with IS_EDITED ATTRIBUTE
    let MODIFIED_MAPPED_DATA;
    if (source_data.current_filter_value === "Existing") {
      MODIFIED_MAPPED_DATA = getSortedModifiedData();
    } else {
      const Temp_Modidified_Data = source_data.modified_mapped_data.map(
        (item) => {
          return {
            actual: {},
            updated: item.updated,
            isEdited: item.isEdited,
            isNew: true,
          };
        },
      );

      MODIFIED_MAPPED_DATA = Temp_Modidified_Data.map((item) => {
        const KEYS = Object.keys(item.updated);
        const Updated = {};

        KEYS.forEach((key) => {
          Updated[key] =
            item.updated[key] === null ? "null" : item.updated[key];
        });

        return {
          actual: {},
          updated: {
            ...Updated,
            COUNTRY: source_data.current_country,
            COUNTRY_CODE: source_data.current_country_code,
            HARBOR_SOURCE_FILE_ID: source_data.current_ssfFileId,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            ISNEW: item?.updated?.ISNEW
              ? item.updated.ISNEW
              : item?.isNew || false,
            USER: user.mail || "",
            CREATED_BY: user.mail || "",
          },
          isEdited: item.isEdited,
          isNew: true,
        };
      });
    }

    try {
      const params = new URLSearchParams({
        dataset_name: source_data?.current_target_gold_layer?.value || "",
        usecase: "gold_template_mapping",
        country: source_data?.current_country || "",
        file_id: source_data?.current_ssfFileId || "",
        target_gold_layer: source_data.current_target_gold_layer.label || "",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/gold_template_mapping/update_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      // Check response for successful DB update
      if (data.statusCode === "harbor-200") {
        clearReduxState();
        getSources();
        setGlobalEdit(false);

        // Toast OnSuccess
        updateAlert({
          open: true,
          message: "All the changes are saved & awaiting for approval",
          severity: "success",
          closeFlag: true,
        });
        setIsSaveAudit(false);
      } else {
        // RESPONSE DATA FROM BACKEND API
        const Response = data.validated_result;

        // STEP 1 = UPDATE CURRENT_MAPPED_DATA RECORDS WITH RESPECTIVE RECORD FROM ACTUAL_UPDATED_COMBINED_DATA
        const Sorted_Mapped_Data = source_data.current_mapped_data.map(
          (item) => {
            // COMPARE MAPPED_DATA WITH RESPONSE DATA AND UPDATE ITS IS_VALIDATED ATTRIBUTE
            const matchedData = Response.find((data) => {
              const Merged_Data =
                source_data.current_filter_value === "Existing"
                  ? mergeWithObj2Priority(data.actual, data.updated)
                  : data.updated;
              // Check if all duplicate validation attributes match
              return source_data.data.dropdown.duplicate_validation_attributes.every(
                (attribute) => {
                  return item.rowData[attribute] === Merged_Data[attribute];
                },
              );
            });

            return {
              ...item,
              isEdited: matchedData
                ? matchedData.isEdited === "true"
                  ? true
                  : false
                : item.isEdited,
              isValidated: matchedData
                ? matchedData.isValidation === "true"
                  ? true
                  : false
                : item.isValidated,
              errorMessage:
                matchedData.isValidation === "false"
                  ? matchedData.exception_details
                  : "",
            };
          },
        );

        // STEP 2 = SORTING THE Sorted_Mapped_Data By keeping the Items with isValidated = false at top
        const FINAL_SORTED_MAPPED_DATA = Sorted_Mapped_Data.sort((a, b) => {
          return a.isValidated - b.isValidated;
        });

        updateSourceInputs("current_mapped_data", FINAL_SORTED_MAPPED_DATA);
        updateSourceInputs("appliedFilters", []);
        updateSourceInputs("searchValue", "");
        updateSourceInputs("filtered_Rows", []);
        updateSourceInputs("is_initial", false);

        // Error Toast
        updateAlert({
          open: true,
          message: "There was an error in the expression validation",
          severity: "Failed ",
          closeFlag: true,
        });
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    setIsTableDataSaving(false);
    setIsSaveAudit(false);
  };

  const setMappedData = async (
    dataset,
    country,
    country_code,
    ssf,
    filter,
    version,
    target_gold_layer,
  ) => {
    setIsPlaceholderFetching(true);
    setIsSearchFilterLoading(true);

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    const Meta_Filters = source_data.data.dropdown.metadata_filter;

    try {
      const params = new URLSearchParams({
        country: country || "",
        country_code: country_code || "",
        file_id: ssf || "",
        dataset_name: dataset || "",
        filtertype: "initial_fetch",
        version_details: version || "",
        target_gold_layer: target_gold_layer || "",
        userid: user.mail || "",
        usecase: "gold_template_mapping",
      });
      const response = await fetch(
        api + `/gold_template_mapping/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data.data.dropdown.is_value_fetch) {
        const VALUES = data?.values_data || {};
        const SAVE_CALL_AUDIT_DETAILS = data?.Audit_result || [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            HARBOR_VALUE: VALUES,
            SAVE_CALL_AUDIT_RESULTS: SAVE_CALL_AUDIT_DETAILS,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        filteredDatasetValue = data?.data || [];

        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
      setIsSearchFilterLoading(false);
      setIsPlaceholderFetching(false);
      updateSourceInputs("has_awaiting_data", false);
      return;
    }

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        if (source_data.current_source.toLowerCase() === "nielsen") {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            COUNTRY_CODE: source_data.current_country_code,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [Meta_Filters?.[1]]: ssf,
          };
        } else {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [Meta_Filters?.[1]]: ssf,
          };
        }
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    if (have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      // TABLE_DROPDOWN_DATA
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("current_mapped_data_main", tableData);
      updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
      setIsSearchFilterLoading(false);
      setIsPlaceholderFetching(false);
    }
  };

  const setMappedDataCreateNew = async (
    dataset,
    country,
    country_code,
    ssf,
    version,
    target_gold_layer,
  ) => {
    setIsPlaceholderFetching(true);
    setIsSearchFilterLoading(true);

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    try {
      const params = new URLSearchParams({
        country: country || "",
        country_code: country_code || "",
        file_id: ssf || "",
        dataset_name: dataset || "",
        filtertype: "create_new",
        version_details: version || "",
        target_gold_layer: target_gold_layer || "",
        userid: user.mail || "",
        usecase: "gold_template_mapping",
      });

      const response = await fetch(
        api + `/gold_template_mapping/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data.data.dropdown.is_value_fetch) {
        const VALUES = data?.values_data || {};
        const SAVE_CALL_AUDIT_DETAILS = data?.Audit_result || [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            HARBOR_VALUE: VALUES,
            SAVE_CALL_AUDIT_RESULTS: SAVE_CALL_AUDIT_DETAILS,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;

        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    let val = DownloadSampleData;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        let rowData = {};
        if (source_data.current_source === "Nielsen") {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: {
              ...item,
              COUNTRY: source_data.current_country,
              COUNTRY_CODE: source_data.current_country_code,
              TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
              [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
            },
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: {
              ...item,
              COUNTRY: source_data.current_country,
              TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
              [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
            },
          };
        }
        ITEM_ID++;
        return rowData;
      });

    const MODIFIED_MAPPED_DATA =
      tableData?.map((rowData) => {
        return {
          actual: {},
          updated: rowData.rowData,
          isEdited: false,
          isNew: true,
        };
      }) ?? [];

    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        if (source_data.current_source === "Nielsen") {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            COUNTRY_CODE: source_data.current_country_code,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
          };
        } else {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
          };
        }
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    if (have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("current_mapped_data_main", tableData);
      updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      setIsSearchFilterLoading(false);
      setIsPlaceholderFetching(false);
    }
  };

  const setMappedDataForExistingTemplate = async (
    dataset,
    country,
    country_code,
    ssf,
    version,
    target_gold_layer,
  ) => {
    setIsPlaceholderFetching(true);
    setIsSearchFilterLoading(true);

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    try {
      const params = new URLSearchParams({
        country: country || "",
        country_code: country_code || "",
        file_id: ssf || "",
        dataset_name: dataset || "",
        filtertype: "create_new",
        version_details: version || "",
        target_gold_layer: target_gold_layer || "",
        userid: user.mail || "",
        usecase: "gold_template_mapping",
      });

      const response = await fetch(
        api + `/gold_template_mapping/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      const Is_Valid_Gold_Layer_For_Is_Value_Fetch =
        source_data?.data?.dropdown?.ignore_gold_layer_list_for_is_value_fetch?.includes(
          source_data?.current_target_gold_layer?.value,
        ) ?? false;

      if (!Is_Valid_Gold_Layer_For_Is_Value_Fetch) {
        if (source_data.data.dropdown.is_value_fetch) {
          const VALUES = data.values_data;
          const UPDATED_DROPDOWN_DATA = {
            ...source_data.data,
            dropdown: {
              ...source_data.data.dropdown,
              HARBOR_VALUE: VALUES,
            },
          };

          updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
        }
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;

        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
    }

    let val = DownloadSampleData;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        let rowData = {};
        if (source_data.current_source === "Nielsen") {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: {
              ...item,
              COUNTRY: source_data.current_country,
              COUNTRY_CODE: source_data.current_country_code,
              TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
              [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
            },
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: false,
            isNewData: false,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: {
              ...item,
              COUNTRY: source_data.current_country,
              TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
              [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
            },
          };
        }
        ITEM_ID++;
        return rowData;
      });

    const MODIFIED_MAPPED_DATA =
      tableData?.map((rowData) => {
        return {
          actual: {},
          updated: rowData.rowData,
          isEdited: false,
          isNew: true,
        };
      }) ?? [];

    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        if (source_data.current_source === "Nielsen") {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            COUNTRY_CODE: source_data.current_country_code,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
          };
        } else {
          rowData = {
            ...Altered_RowData,
            COUNTRY: source_data.current_country,
            TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
            [source_data.data.dropdown.metadata_filter?.[1]]: ssf,
          };
        }
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    if (have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("current_mapped_data_main", tableData);
      updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);
      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      setIsSearchFilterLoading(false);
      setIsPlaceholderFetching(false);
    }
  };

  const fetchAwaitingRecords = async () => {
    setIsDynamicDialogOpen(false);

    let filteredDatasetValue;
    try {
      const params = new URLSearchParams({
        dataset_name: source_data?.current_target_gold_layer?.value || "",
        usecase: "gold_template_mapping",
        country: source_data?.current_country || "",
        file_id: source_data?.current_ssfFileId || "",
        target_gold_layer: source_data.current_target_gold_layer.label || "",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/gold_template_mapping/get_awaiting_table_data?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (data?.statusCode === "harbor-204") {
        updateAlert({
          open: true,
          message: `Mappings not available in the gold template mapping`,
          severity: "warning",
          closeFlag: true,
        });
        return;
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (data && data.data) {
        filteredDatasetValue = data.data;
      }

      // DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "Failed ",
        closeFlag: true,
      });
      setIsSearchFilterLoading(false);
      setIsPlaceholderFetching(false);
      updateSourceInputs("has_awaiting_data", false);
      return;
    }

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    const tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("current_mapped_data_main", tableData);

    setIsSearchFilterLoading(false);
    setIsPlaceholderFetching(false);
  };

  const handleCreateNewRow = () => {
    setIsSearchFilterLoading(true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    let filteredDatasetValue;
    let tableData;

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const CURRENT_MAPPED_DATA = source_data.current_mapped_data;
    let NewRowData = source_data.data.dropdown.insert_column_attributes;
    NewRowData = {
      ...NewRowData,
      COUNTRY: source_data.current_country,
      TARGET_GOLD_LAYER: source_data.current_target_gold_layer.label,
      [Meta_Filters[1]]: source_data.current_ssfFileId,
    };
    filteredDatasetValue = [NewRowData, ...CURRENT_MAPPED_DATA];

    let val = filteredDatasetValue;
    let ITEM_ID = 0;
    tableData =
      val &&
      val.map((item) => {
        let rowData;
        if (item.rowData) {
          rowData = {
            ...item,
            item_Id: ITEM_ID,
          };
        } else {
          rowData = {
            item_Id: ITEM_ID,
            isEditing: true,
            isNewData: true,
            isEdited: false,
            isValidated: true,
            isCheckedRow: false,
            errorMessage: "",
            rowData: item,
          };
        }
        ITEM_ID++;
        return rowData;
      });

    // // TABLE_DROPDOWN_DATA
    updateSourceInputs("any_row_isEditing", true);
    updateSourceInputs("current_mapped_data", tableData);
    updateSourceInputs("isNewDataInserted", true);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    setIsSearchFilterLoading(false);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const testRecords = (records) => {
    let MissingValues = {};
    const Current_Table_Data = records || [];

    const TABLE_HEAD_COLUMN_LIST =
      source_data?.data?.dropdown?.table_header_column_list || [];
    const EDIT_COLUMN_LIST =
      source_data?.data?.dropdown?.edit_model_column_list || [];
    const Free_Text_Applicable_Columns =
      source_data?.data?.dropdown?.free_text_applicable_columns || [];
    const DROPDOWN_DATA = source_data?.data?.dropdown || {};
    const Free_text_applicable_columns_for_Gold_target_column =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_target_column_name || [];
    const Free_text_applicable_columns_for_Harbor_Value =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_harbor_value || [];

    Current_Table_Data.forEach((item) => {
      TABLE_HEAD_COLUMN_LIST.forEach((column) => {
        // Skip if value is null
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        // Skip HARBOR_VALUE, GOLD_TARGET_COLUMN_NAME validation for mapped types
        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          column.name === "GOLD_TARGET_COLUMN_NAME" &&
          Free_text_applicable_columns_for_Gold_target_column &&
          Free_text_applicable_columns_for_Gold_target_column.length > 0 &&
          Free_text_applicable_columns_for_Gold_target_column.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          column.name === "HARBOR_VALUE" &&
          Free_text_applicable_columns_for_Harbor_Value &&
          Free_text_applicable_columns_for_Harbor_Value.length > 0 &&
          Free_text_applicable_columns_for_Harbor_Value.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        // === DEPENDENT COLUMN CHECK ===
        if (column.is_dependent) {
          let FinalOptions = [];
          const FilteredDropdownOptions = DROPDOWN_DATA[column.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          if (column.isMultiLayerArray) {
            const Parent_Column_Name = column.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name];

            const DEFAULT_VALUE_KEYS = Object.keys(
              DROPDOWN_DATA[column.multiLayerMetaName].defaultvalues,
            );

            const Is_Default = DEFAULT_VALUE_KEYS.includes(Parent_Column_Value);

            if (Is_Default) {
              const Default_Value_Key_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.defaultvalues?.[
                  Parent_Column_Value
                ] || "";

              FinalOptions =
                Default_Value_Key_Name && Default_Value_Key_Name.length > 0
                  ? FilteredDropdownOptions?.[Default_Value_Key_Name] || []
                  : [];

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              if (!isValidated) {
                MissingValues[column.name] = [
                  ...(MissingValues[column.name] || []),
                  item.rowData[column.name],
                ];
              }
              return;
            } else {
              const Value_key_name = Object.keys(FilteredDropdownOptions).find(
                (vkey) => {
                  if (!Parent_Column_Value || !Parent_Column_Value.length > 0)
                    return "";
                  return (
                    vkey.toLowerCase() === Parent_Column_Value.toLowerCase()
                  );
                },
              );

              const Layer_Two_Parent_Column_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.[
                  Parent_Column_Value
                ] || "";

              const Layer_Two_Parent_Column_Value =
                item.rowData[Layer_Two_Parent_Column_Name];

              const Parent_Column_Value_List_From_Meta =
                DROPDOWN_DATA
                  ?.cross_mapping_metadata_for_harbor_value_for_olt?.[
                  item?.rowData?.[Layer_Two_Parent_Column_Name] || ""
                ];
              Parent_Column_Value_List_From_Meta?.forEach((item) => {
                const newOptions = FilteredDropdownOptions?.[item];
                FinalOptions = [...FinalOptions, ...newOptions];
              });

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              if (!isValidated) {
                MissingValues[column.name] = [
                  ...(MissingValues[column.name] || []),
                  item.rowData[column.name],
                ];
              }
              return;
            }
          } else {
            const Parent_Column_Name = column.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

            // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
            const filteredFinalOptions =
              Parent_Column_Value !== null
                ? FilteredDropdownOptions.find(
                    (option) =>
                      option[Parent_Column_Name] === Parent_Column_Value,
                  )
                : {};

            FinalOptions =
              filteredFinalOptions &&
              Object.keys(filteredFinalOptions).length > 0
                ? filteredFinalOptions[column.name]
                : [];

            const isValidated =
              FinalOptions?.includes(item.rowData[column.name]) ?? false;

            if (!isValidated) {
              MissingValues[column.name] = [
                ...(MissingValues[column.name] || []),
                item.rowData[column.name],
              ];
            }
            return;
          }
        }

        // === NORMAL COLUMN VALIDATION ===
        const editableColumn = EDIT_COLUMN_LIST.find(
          (data) => data.name === column.name && data.type === "select",
        );

        if (editableColumn) {
          const IS_ARRAY = editableColumn.isArray;
          const DROPDOWN_DATA_NEW = source_data?.data?.dropdown || {};
          const Final_DropDown_Values = DROPDOWN_DATA_NEW[column.name] || [];

          let resultValid = false;

          if (IS_ARRAY) {
            if (Final_DropDown_Values.length === 0) {
              resultValid = true;
            } else {
              resultValid = Final_DropDown_Values.includes(
                item.rowData[column.name],
              );
            }
          } else {
            resultValid =
              Free_Text_Applicable_Columns.includes(column.name) &&
              Free_text_applicable_columns_for_Gold_target_column.includes(
                item?.rowData?.MAPPING_TYPE,
              ) &&
              Free_text_applicable_columns_for_Harbor_Value.includes(
                item?.rowData?.MAPPING_TYPE,
              )
                ? true
                : Array.isArray(Final_DropDown_Values) &&
                  Final_DropDown_Values.includes(item.rowData[column.name]);
          }

          if (!resultValid) {
            MissingValues[column.name] = [
              ...(MissingValues[column.name] || []),
              item.rowData[column.name],
            ];
          }
        }
      });
    });
    return MissingValues;
  };

  function formatValidationErrorDetails(errorObj) {
    if (!errorObj || typeof errorObj !== "object") return "";

    return Object.entries(errorObj)
      .map(([key, values]) => {
        if (Array.isArray(values) && values.length > 0) {
          return `${key}: ${values.join(", ")}`;
        }
        return null;
      })
      .filter(Boolean)
      .join(" | ");
  }

  const handleValidateFileData = (tableData) => {
    updateAlert({
      open: true,
      message: "Validating row data's",
      severity: "success",
      closeFlag: true,
    });

    const Current_Table_Data = tableData;
    const DROPDOWN_DATA = source_data?.data?.dropdown || {};
    const TABLE_HEAD_COLUMN_LIST =
      source_data.data.dropdown.table_header_column_list;
    const EDIT_COLUMN_LIST = source_data.data.dropdown.edit_model_column_list;
    const Free_Text_Applicable_Columns =
      source_data?.data?.dropdown?.free_text_applicable_columns || [];
    const Free_text_applicable_columns_for_Gold_target_column =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_target_column_name || [];
    const Free_text_applicable_columns_for_Harbor_Value =
      source_data?.data?.dropdown
        ?.free_text_applicable_values_for_harbor_value || [];

    // test
    const failedRecord = testRecords(Current_Table_Data);
    const errorDetails = formatValidationErrorDetails(failedRecord);

    const isValid = Current_Table_Data.every((item, indxxx) => {
      const result = TABLE_HEAD_COLUMN_LIST.every((column) => {
        if (
          !source_data?.data?.dropdown?.duplicate_validation_attributes?.includes(
            column.name,
          ) &&
          (item.rowData[column.name] === "null" ||
            item.rowData[column.name] === "" ||
            item.rowData[column.name] === null ||
            item.rowData[column.name]?.length === 0)
        ) {
          return true;
        }

        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          column.name === "GOLD_TARGET_COLUMN_NAME" &&
          Free_text_applicable_columns_for_Gold_target_column &&
          Free_text_applicable_columns_for_Gold_target_column.length > 0 &&
          Free_text_applicable_columns_for_Gold_target_column.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        if (
          Free_Text_Applicable_Columns.includes(column.name) &&
          column.name === "HARBOR_VALUE" &&
          Free_text_applicable_columns_for_Harbor_Value &&
          Free_text_applicable_columns_for_Harbor_Value.length > 0 &&
          Free_text_applicable_columns_for_Harbor_Value.includes(
            item?.rowData?.MAPPING_TYPE,
          )
        ) {
          return true;
        }

        if (column.is_dependent) {
          let FinalOptions = [];
          const FilteredDropdownOptions = DROPDOWN_DATA[column.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          if (column.isMultiLayerArray) {
            const Parent_Column_Name = column.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name];

            const DEFAULT_VALUE_KEYS = Object.keys(
              DROPDOWN_DATA[column.multiLayerMetaName].defaultvalues,
            );

            const Is_Default = DEFAULT_VALUE_KEYS.includes(Parent_Column_Value);

            if (Is_Default) {
              const Default_Value_Key_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.defaultvalues?.[
                  Parent_Column_Value
                ] || "";

              FinalOptions =
                Default_Value_Key_Name && Default_Value_Key_Name.length > 0
                  ? FilteredDropdownOptions?.[Default_Value_Key_Name] || []
                  : [];

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              return isValidated;
            } else {
              const Layer_Two_Parent_Column_Name =
                DROPDOWN_DATA?.[column.multiLayerMetaName]?.[
                  Parent_Column_Value
                ] || "";

              const Parent_Column_Value_List_From_Meta =
                DROPDOWN_DATA
                  ?.cross_mapping_metadata_for_harbor_value_for_olt?.[
                  item?.rowData?.[Layer_Two_Parent_Column_Name] || ""
                ];

              let filteredFinalOptions = [];
              Parent_Column_Value_List_From_Meta?.forEach((item) => {
                const newOptions = FilteredDropdownOptions?.[item];
                filteredFinalOptions = [...filteredFinalOptions, ...newOptions];
              });

              FinalOptions =
                filteredFinalOptions && filteredFinalOptions.length > 0
                  ? filteredFinalOptions || []
                  : [];

              const isValidated =
                FinalOptions?.includes(item.rowData[column.name]) ?? false;

              return isValidated;
            }
          } else {
            const Parent_Column_Name = column.parent_column; // DEPENDENCY COLUMN NAME

            const Parent_Column_Value = item.rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

            // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
            const filteredFinalOptions =
              Parent_Column_Value !== null
                ? FilteredDropdownOptions.find(
                    (option) =>
                      option[Parent_Column_Name] === Parent_Column_Value,
                  )
                : {};

            FinalOptions =
              filteredFinalOptions &&
              Object.keys(filteredFinalOptions).length > 0
                ? filteredFinalOptions[column.name]
                : [];

            const isValidated =
              FinalOptions?.includes(item.rowData[column.name]) ?? false;

            return isValidated;
          }
        } else {
          // CHECKS IF COLUMN IN THE CURRENT ITERATION HAS DROPDOWN FIELD
          let result = EDIT_COLUMN_LIST.find(
            (data) => data.type === "select" && column.name === data.name,
          );

          // IF YES THEN CHECKS IF THE COLUMNS DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          if (result && result.type === "select") {
            let Final_DropDown_Values;
            EDIT_COLUMN_LIST.map((editItem) => {
              if (editItem.name === column.name && editItem.isArray) {
                Final_DropDown_Values = DROPDOWN_DATA[column.name];
              }
            });

            const isValidated =
              Final_DropDown_Values?.includes(item.rowData[column.name]) ??
              false;

            return isValidated;
          }
        }
      });
      return result;
    });

    if (isValid) {
      updateAlert({
        open: true,
        message: "File data validated successfully",
        severity: "success",
        closeFlag: true,
      });
      updateSourceInputs("is_table_loading", false);
      setIsFileUploading(false);

      const MODIFIED_MAPPED_DATA = Current_Table_Data.map((item) => {
        return {
          actual: {},
          isNew: false,
          isEdited: true,
          updated: { ...(item?.rowData || {}) },
        };
      });

      updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
      updateSourceInputs("current_mapped_data", tableData);
      updateSourceInputs("isFileUploaded", true);
      updateSourceInputs("is_file_uploaded", true);
    } else {
      updateSourceInputs("is_initial", true);
      updateAlert({
        open: true,
        message: `Validation Failed! Invalid column value found in these columns ---> ${errorDetails}`,
        severity: "success",
        closeFlag: true,
      });
    }

    setIsFileUploading(false);
  };

  const validateMetaSelectionColumns = (tdata) => {
    let hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    tdata?.forEach((item) => {
      if (
        !item["COUNTRY"] ||
        item["COUNTRY"] === "" ||
        item["COUNTRY"] === null ||
        item["COUNTRY"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (
        source_data?.current_source.toLowerCase() === "nielsen" &&
        (!item["COUNTRY_CODE"] ||
          item["COUNTRY_CODE"] === "" ||
          item["COUNTRY_CODE"] === null ||
          item["COUNTRY_CODE"] === undefined)
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage:
            "Invalid country code value found in the uploaded file.",
        };
        return;
      }
      if (
        !item["HARBOR_SOURCE_FILE_ID"] ||
        item["HARBOR_SOURCE_FILE_ID"] === "" ||
        item["HARBOR_SOURCE_FILE_ID"] === null ||
        item["HARBOR_SOURCE_FILE_ID"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid SFF File ID value found in the uploaded file.",
        };
        return;
      }

      if (item["COUNTRY"] !== source_data?.current_country) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (
        source_data?.current_source.toLowerCase() === "nielsen" &&
        item["COUNTRY_CODE"] !== source_data?.current_country_code
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage:
            "Invalid country code value found in the uploaded file.",
        };
        return;
      }
      if (item["HARBOR_SOURCE_FILE_ID"] !== source_data?.current_ssfFileId) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid SFF File ID value found in the uploaded file.",
        };
        return;
      }
      hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    });
    return hasValidValuesForMetaColumns;
  };

  const handleFileUpload = (records) => {
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", true);
    setIsFileUploading(true);

    const Current_Table_Data = records || [];
    const validationResult = validateMetaSelectionColumns(Current_Table_Data);

    if (validationResult && validationResult.status) {
      updateSourceInputs("isFileUploaded", false);
      updateSourceInputs("is_file_uploaded", false);
      updateSourceInputs("is_initial", true);
      setIsFileUploading(false);
      updateAlert({
        open: true,
        message: `Validation Failed. ${
          validationResult?.errorMessage || "Please check the uploaded file."
        }`,
        severity: "warning",
        closeFlag: true,
      });
      return;
    }

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    const Existing_Records = source_data.current_mapped_data;
    const XL_FILE_RECORDS = records.map((item) => {
      return {
        ...item,
        CREATED_AT: item.CREATED_AT || null,
        CREATED_BY: item.CREATED_BY || null,
        UPDATED_AT: item.UPDATED_AT || null,
        UPDATED_BY: item.UPDATED_BY || null,
      };
    });

    const FILTEREDRECORDS = XL_FILE_RECORDS.map((item, i) => {
      const existing_Data = Existing_Records?.[i];
      return { ...(existing_Data?.rowData || {}), ...item };
    });

    let ITEM_ID = 0;
    const tableData =
      FILTEREDRECORDS &&
      FILTEREDRECORDS.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isNewData: false,
          isEdited: false,
          isValidated: true,
          isCheckedRow: false,
          errorMessage: "",
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    handleValidateFileData(tableData);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const getApprovalData = async () => {
    clearReduxState();
    setLoading(true);
    try {
      const params = new URLSearchParams({
        usecase_name: "gold_template_mapping",
        user_name: user.mail || "",
      });
      const response = await fetch(
        api + `/approval/getapprovaldata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("approvalData", data.data);
      updateSourceInputs(
        "approvalTable_Header",
        data?.metadata?.table_headers || [],
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getHistoryAndLogsData = async () => {
    clearReduxWithoutGoldLayerState();
    setLoading(true);
    try {
      // code for initial data fetching
      const response = await fetch(
        api +
          `/gold_template_mapping/getdataset?role=${
            user?.role?.[0] || "AppAdmin"
          }`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });

          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("data_logs", data);

      const DATASETS = data.data.map((item) => {
        return {
          label:
            item.dataset_name !== "Nielsen"
              ? item.dataset_name.toUpperCase()
              : item.dataset_name,
          value: item.dataset_name,
        };
      });
      updateSourceInputs("current_mapped_source_logs", DATASETS);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "warning",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDynamicDialogCancel = () => {
    setIsDynamicDialogOpen(false);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("is_initial", true);
    setIsSearchFilterLoading(false);
    setIsPlaceholderFetching(false);
  };

  const goBackFunction = () => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs(
      "current_mapped_data",
      source_data?.current_mapped_data_main,
    );
    setIsBackDialogOpen(false);
  };

  // CONSTANTS
  const SOURCE_DATASET_LIST =
    source_data?.current_mapped_source &&
    source_data?.current_mapped_source.map((data) => {
      return data.toString();
    });

  const SOURCE_DATA_SET_SELECTED =
    SOURCE_DATASET_LIST &&
    SOURCE_DATASET_LIST.map((data) => {
      return { label: data, value: data };
    });

  // USE EFFECTS
  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  useEffect(() => {
    const fetchData = async () => {
      await getSources();
    };
    fetchData();
  }, []);

  return (
    <>
      <LayoutTopSideBottom match={match}>
        {/* Breadcrumbs and Approval Option */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: is_Approver ? "10px" : "0px",
          }}
        >
          <Breadcrumbs match={match} />
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            {is_Approver && !isSaveAudit && !isHistory && (
              <ApprovalButton
                buttonText={
                  source_data?.data?.dropdown?.history_details?.button_text ||
                  "Approval"
                }
                getApprovalData={getApprovalData}
                isApproval={isApproval}
                setIsApproval={setIsApproval}
                getSources={getSources}
                isTableDataLoading={
                  !source_data.is_initial && source_data.is_table_loading
                }
                any_row_isEditing={source_data?.any_row_isEditing}
                sourceData={source_data}
              />
            )}

            {!isSaveAudit && !isApproval && (
              <HistoryAndLogsButton
                buttonText={
                  source_data?.data?.dropdown?.approver_details?.button_text ||
                  "History & Logs"
                }
                getHistoryAndLogsData={getHistoryAndLogsData}
                isHistory={isHistory}
                setIsHistory={setIsHistory}
                getSources={getSources}
                isTableDataLoading={
                  !source_data.is_initial && source_data.is_table_loading
                }
                any_row_isEditing={source_data?.any_row_isEditing}
                sourceData={source_data}
                clearReduxStateForHistoryLogs={clearReduxStateForHistoryLogs}
              />
            )}
          </div>
        </div>

        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={"gold_template_mapping"}
          />
        ) : isHistory ? (
          <HistoryAndLogsTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getHistoryAndLogsData={getHistoryAndLogsData}
            usecase_name={"gold_template_mapping"}
            updateSourceInputs={updateSourceInputs}
            loading={loading}
          />
        ) : isSaveAudit ? (
          <>
            <SaveCallAuditLogs sourceData={source_data} />
          </>
        ) : (
          <MetaSearchFilter
            loading={loading}
            setLoading={setLoading}
            setMappedData={setMappedData}
            setMappedDataCreateNew={setMappedDataCreateNew}
            setMappedDataForExistingTemplate={setMappedDataForExistingTemplate}
            isSearchFilterLoading={isSearchFilterLoading}
            handleFileUpload={handleFileUpload}
            isFileUploading={isFileUploading}
            isPlaceholderFetching={isPlaceholderFetching}
          />
        )}

        {/* Loader new code */}
        {!source_data.is_initial ? (
          !source_data.is_table_loading ? (
            <>
              <EditableTable
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                getData={getData}
                handleFileUpload={handleFileUpload}
                isFileUploading={isFileUploading}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
                sourceDatasetSelected={SOURCE_DATA_SET_SELECTED}
                setIsSearchFilterLoading={setIsSearchFilterLoading}
              />

              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* INSERT NEW BUTTON */}
                  <div>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={handleCreateNewRow}
                      disabled={isSearchFilterLoading || IS_ANY_ROWDATA_NULL}
                    >
                      <span>Insert new</span>
                    </Button>
                  </div>

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text,
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <div className="">
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsBackDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Back
                    </Button>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>

                    {IS_ANY_RECORDS_EDITED && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleDialogOpen}
                        disabled={IS_SAVE_BUTTON_ENABLE}
                      >
                        <span>Save</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be created as a new version. Do
                        you want to continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={
                        source_data.has_awaiting_data.has_records
                          ? onSaveAwaitingData
                          : onSave
                      }
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* BACK DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isBackDialogOpen}
                  onClose={() => setIsBackDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsBackDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={goBackFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          ) : (
            <Loader />
          )
        ) : (
          <div style={{ textAlign: "center" }}>
            {/* Choose the above mapping filters */}
          </div>
        )}

        {
          <DynamicDialog
            openModal={isDynamicDialogOpen}
            closeModel={handleDynamicDialogCancel}
            title={"Confirmation"}
            hasCustomCancelButton={true}
            content={
              <p style={{ fontSize: "16px", color: "black", marginTop: "6px" }}>
                {dynamicDialogMessage}
              </p>
            }
            actions={
              <>
                <Button
                  onClick={handleDynamicDialogCancel}
                  style={{
                    fontFamily: "Hind Siliguri",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {source_data.has_awaiting_data.has_access ? "Cancel" : "Ok"}
                </Button>
                {source_data.has_awaiting_data.has_access && (
                  <Button
                    onClick={fetchAwaitingRecords}
                    style={{
                      backgroundColor: "#46596A",
                      fontFamily: "Hind Siliguri",
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      color: "white",
                    }}
                  >
                    fetch
                  </Button>
                )}
              </>
            }
          />
        }

        {/* Loader new code end */}
      </LayoutTopSideBottom>

      {/* Table view*/}
    </>
  );
}

GoldTemplateView.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  brand_data: PropTypes.object,
  cncData: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  // userData:state.cncStateData.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GoldTemplateView),
);
